<template>
    <div v-if="getAdviceDetail != null && Object.entries(getAdviceDetail).length !== 0"
         class="modal-mask"
         :class="{modal:true, fade:true, 'slide-right':true, show:(getAdviceDetail != null)}"
         id="adviesmodal"
         tabindex="-1"
         role="dialog"
         :style="`display: ${getAdviceDetail != null ? 'block' : 'none'};`"
         aria-labelledby="myModalLabel"
         :aria-hidden="getAdviceDetail == null"
         @click="$emit('close-modal')">
    <div class="modal-dialog modal-lg">
      <div class="modal-content-wrapper">
        <div class="modal-content table-block"
             @click="preventModalClick">

          <button type="button" class="close" aria-hidden="true"
                  @click="$emit('close-modal')">
            <i class="pg-close fs-14"></i>
          </button>

           <AdviceContent class="modal-body v-align-middle"/>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import AdviceContent from './AdviceContent'

export default {
    components: { AdviceContent},
    computed: {
      ...mapGetters([
        'getAdviceDetail',
      ]),
    },
  methods: {
    ...mapActions([
      'loadTimeBlockAdvice',
      'loadAdviceDetails',
    ]),
    preventModalClick (event) {
      event.stopPropagation()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/myschedule/Advice.vue